// src/util/patch-lifecycle.ts
var extensionsKey = Symbol();
function patch_lifecycle_default(component, methods) {
  const proto = component.__proto__;
  const extensions = proto[extensionsKey];
  if (extensions) {
    if (!extensions.has(methods)) {
      extensions.add(methods);
      addMethods(proto, methods);
      return true;
    }
  } else {
    proto[extensionsKey] = /* @__PURE__ */ new Set([methods]);
    addMethods(proto, methods);
    return true;
  }
  return false;
}
function addMethods(proto, methods) {
  for (const name in methods) {
    proto[name] = callBoth(proto[name], methods[name]);
  }
}
function callBoth(a, b) {
  if (a) {
    return function() {
      a.call(this);
      b.call(this);
    };
  }
  return b;
}

export {
  patch_lifecycle_default
};
